import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import '../../components/MsvDetailShell/MsvDetailShell.css';
import './MsvPageHeadWithBack.css';

const MsvPageHeadWithBack = ({
    eyebrow,
    title,
    onBack,
    backLabel = 'Back',
    className = '',
}) => (
    <div className={`msv-page-head msv-page-head--with-back ${className}`.trim()}>
        <button type="button" className="msv-detail-back-btn msv-page-head-back-btn" onClick={onBack}>
            <FiChevronLeft aria-hidden />
            {backLabel}
        </button>
        <div className="msv-page-head-center">
            {eyebrow && <p className="msv-page-eyebrow">{eyebrow}</p>}
            <h1 className="msv-page-title">{title}</h1>
            <div className="msv-finish-line" />
        </div>
    </div>
);

export default MsvPageHeadWithBack;
